import { styled } from '@mui/material/styles'
import { primary, primaryLight } from '@/constant'

export type BadgeType = 'success' | 'info' | 'warning' | 'disabled' | 'error';

export type BadgeShap = 'square' | 'rounded';

const BadgeStyle = (bordered: boolean, gradient: boolean) => ({
  success: {
    backgroundColor: primaryLight,
    color: primary,
    ...(bordered && { border: `1px solid ${primary}` }),
    ...(gradient && {
      background: 'linear-gradient(to left,#ADEF8D,#F5FFF1)',
    }),
  },
  info: {
    backgroundColor: '#0091FF1A',
    color: '#0091FFFF',
    ...(bordered && { border: `1px solid ${'#0091FFFF'}` }),
  },
  warning: {
    backgroundColor: '#FFBF001A',
    color: '#FFBF00FF',
    ...(bordered && { border: `1px solid ${'#FFBF00FF'}` }),
    ...(gradient && {
      background: 'linear-gradient(to left,#FFF5E3,#FFE5B0)',
    }),
  },
  error: {
    backgroundColor: '#FFBF001A',
    color: '#997033',
    ...(bordered && { border: `1px solid ${'#FFBF00FF'}` }),
    ...(gradient && {
      background: 'linear-gradient(to left,#FFF5E3,#FFE5B0)',
    }),
  },
  disabled: {
    backgroundColor: '#F7F7F7FF',
    color: '#BFBFBFFF',
    ...(bordered && { border: `1px solid ${'#BFBFBFFF'}` }),
    ...(gradient && {
      background:
        'linear-gradient(to left,#F7F7F7 100%,#F7F7F7 85%, #F7F7F7 70%)',
    }),
  },
})

const Badge = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'type' &&
    prop !== 'bordered' &&
    prop !== 'shape' &&
    prop !== 'backgroundstyle',
})<{
  type: BadgeType;
  bordered: 'true' | 'false';
  shape: BadgeShap;
  backgroundstyle?: 'gradient';
}>(({ type, bordered, shape, backgroundstyle }) => ({
  display: 'flex',
  padding: '0 10px',
  alignItems: 'center',
  borderRadius: shape === 'rounded' ? '25px' : '0',
  ...BadgeStyle(bordered === 'true', backgroundstyle === 'gradient')[type],
}))

export default Badge
